import { posService } from './posService';

export interface Payment {
  id: number;
  order_id: number;
  payment_method: string;
  amount: number;
  reference_number?: string;
  notes?: string;
  created_at: string;
}

export const paymentService = {
  // Tạo thanh toán
  createPayment: async (data: {
    orderId: number;
    amount: number;
    method: string;
    referenceNumber?: string;
    notes?: string;
  }): Promise<Payment> => {
    try {
      // Chuẩn bị payload đúng format cho API
      const paymentData = {
        payment_method: data.method,
        amount: data.amount,
        reference_number: data.referenceNumber || null,
        notes: data.notes || ''
      };

      console.log('Creating payment with data:', paymentData);

      const response = await posService.createPayment(data.orderId, paymentData);

      console.log('Payment API response:', response);

      // API có thể chỉ trả về message mà không có data
      if (!response.data) {
        console.log('Payment created successfully, no data returned');
        return {
          id: Date.now(), // Fallback ID
          order_id: data.orderId,
          payment_method: data.method,
          amount: data.amount,
          reference_number: data.referenceNumber,
          notes: data.notes,
          created_at: new Date().toISOString()
        };
      }

      return {
        id: response.data.id || Date.now(), // Fallback ID nếu API không trả về
        order_id: data.orderId,
        payment_method: data.method,
        amount: data.amount,
        reference_number: data.referenceNumber,
        notes: data.notes,
        created_at: new Date().toISOString()
      };
    } catch (error) {
      console.error('Error creating payment:', error);
      throw error;
    }
  },

  // Lấy lịch sử thanh toán
  getPaymentHistory: async (orderId: number): Promise<Payment[]> => {
    try {
      const payments = await posService.getPaymentHistory(orderId);
      return payments.map((payment: any) => ({
        id: payment.id,
        order_id: payment.order_id,
        payment_method: payment.payment_method,
        amount: payment.amount,
        reference_number: payment.reference_number,
        notes: payment.notes,
        created_at: payment.created_at
      }));
    } catch (error) {
      console.error('Error getting payment history:', error);
      throw error;
    }
  },

  // Tính tổng tiền đã thanh toán
  calculateTotalPaid: (payments: Payment[]): number => {
    return payments.reduce((total, payment) => total + payment.amount, 0);
  },

  // Kiểm tra xem đơn hàng đã thanh toán đủ chưa
  isFullyPaid: (totalAmount: number, payments: Payment[]): boolean => {
    const totalPaid = paymentService.calculateTotalPaid(payments);
    return totalPaid >= totalAmount;
  }
};